import React, { useRef, useEffect } from "react";
import "./TabBar.css";

const TabBar = ({ children }) => {
  const tabBarRef = useRef(null);

  useEffect(() => {
    const tabBar = tabBarRef.current;
    if (!tabBar) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    const mouseDownHandler = (e) => {
      isDown = true;
      startX = e.pageX - tabBar.offsetLeft;
      scrollLeft = tabBar.scrollLeft;
    };

    const mouseLeaveHandler = () => {
      isDown = false;
    };

    const mouseUpHandler = () => {
      isDown = false;
    };

    const mouseMoveHandler = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tabBar.offsetLeft;
      const walk = (x - startX) * 1; // Adjust multiplier if needed
      tabBar.scrollLeft = scrollLeft - walk;
    };

    const touchStartHandler = (e) => {
      startX = e.touches[0].pageX - tabBar.offsetLeft;
      scrollLeft = tabBar.scrollLeft;
    };

    const touchMoveHandler = (e) => {
      const x = e.touches[0].pageX - tabBar.offsetLeft;
      const walk = x - startX;
      tabBar.scrollLeft = scrollLeft - walk;
    };

    tabBar.addEventListener("mousedown", mouseDownHandler);
    tabBar.addEventListener("mouseleave", mouseLeaveHandler);
    tabBar.addEventListener("mouseup", mouseUpHandler);
    tabBar.addEventListener("mousemove", mouseMoveHandler);
    tabBar.addEventListener("touchstart", touchStartHandler);
    tabBar.addEventListener("touchmove", touchMoveHandler);

    return () => {
      tabBar.removeEventListener("mousedown", mouseDownHandler);
      tabBar.removeEventListener("mouseleave", mouseLeaveHandler);
      tabBar.removeEventListener("mouseup", mouseUpHandler);
      tabBar.removeEventListener("mousemove", mouseMoveHandler);
      tabBar.removeEventListener("touchstart", touchStartHandler);
      tabBar.removeEventListener("touchmove", touchMoveHandler);
    };
  }, []);

  return <div className="right-details-tabs" ref={tabBarRef}>{children}</div>;
};

export default TabBar;
